import React from "react";
import { IconContext } from "react-icons";
import { Link } from "react-router-dom";
import { addTooltip } from "./utils";

const IconLink = ({ to = "#", Icon, iconConfig = {}, tooltip, onClick, ...props }) => {
  const isAbsoluteUrl = to.startsWith("http://") || to.startsWith("https://");
  const link = isAbsoluteUrl ? (
    <a href={to} onClick={onClick} {...props}>
      <IconContext.Provider value={iconConfig}>{React.cloneElement(<Icon />)}</IconContext.Provider>
    </a>
  ) : (
    <Link to={to} onClick={onClick} {...props}>
      <IconContext.Provider value={iconConfig}>{React.cloneElement(<Icon />)}</IconContext.Provider>
    </Link>
  );

  if (tooltip) {
    return addTooltip(link, tooltip, props.tooltipPlacement);
  }
  return link;
};

export default IconLink;
